import { useCallback, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { Metric, onCLS, onFCP, onFID, onLCP, onTTFB } from 'web-vitals';

import appLogger, { SeverityLevel } from '../../../logging/appLogger';

const WebVitals = () => {
    const location = useLocation();

    const logPerformance = useCallback(
        (metric: Metric) => {
            let pageName = location.pathname.replace('/', '');

            if (pageName == '') {
                pageName = 'home';
            }

            const measurement = {
                message: `${pageName} web-vital`,
                severityLevel: SeverityLevel.Verbose,
                properties: {
                    metric,
                    name: metric.name,
                    type: 'performance',
                    value: metric.value,
                },
            };

            appLogger.logTrace(measurement);
        },
        [location.pathname]
    );

    useEffect(() => {
        onCLS(logPerformance);
        onFID(logPerformance);
        onFCP(logPerformance);
        onLCP(logPerformance);
        onTTFB(logPerformance);
        // Only call this during pageload.
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return <></>;
};

export default WebVitals;
